// Keep the native-app redirect synchronous with the user's tap. In a preview
// frame, request it from the top-level browser rather than the embedded page.
export function redirectToPhoneApp(href, browser = window) {
  if (!/^(tel|sms):\+?[0-9]+(\?&?body=\S*)?$/.test(href)) return false;

  try {
    if (browser.top && browser.top !== browser) {
      browser.top.location.href = href;
      return true;
    }
  } catch {
    // A host may disallow top-level navigation; still try the native protocol
    // from this frame while the original user activation remains available.
  }

  try {
    browser.location.assign(href);
    return true;
  } catch {
    return false;
  }
}